import ActionType from "../ActionType";
const loginErrorAction = {
    type: ActionType.LOGIN_ERROR_LOADING
};
export default loginErrorAction;